import { inject, Pipe, PipeTransform } from '@angular/core';
import { LanguageService, TreatmentStatusType } from '../../core';


/**
 * Pipe to convert Plan Status enum to display value.
 */
@Pipe({
	name: 'planStatusLabel'
})
export class PlanStatusLabelPipe implements PipeTransform {

	private readonly langSrv = inject(LanguageService);


	transform(planStatus: TreatmentStatusType): string {
		switch (planStatus) {
			case TreatmentStatusType.PUBLISHED: return this.langSrv.labels().PLAN_STATUS_PUBLISHED;
			case TreatmentStatusType.REVOKED: return this.langSrv.labels().PLAN_STATUS_REVOKED;
			default: return planStatus;
		}
	}

}
